(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    // Open the first accordion row on product pages by default
  (function () {
    function openFirstAccordion() {
      document.querySelectorAll('.template-product .accordion').forEach(function (accordion) {
        var firstDetails = accordion.querySelector('details');
        if (firstDetails && !firstDetails.hasAttribute('open')) {
          firstDetails.setAttribute('open', '');
        }
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', openFirstAccordion);
    } else {
      openFirstAccordion();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
